import copy from 'copy-to-clipboard';
import React, { useState } from 'react';

import { SimpleTooltip } from '@eluve/components';
import {
  Button,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
} from '@eluve/components';

interface IdItem {
  label: string;
  value: string | null | undefined;
}

export interface FileIdsPopoverProps {
  ids: IdItem[];
}

export const FileIdsPopover: React.FC<FileIdsPopoverProps> = ({ ids }) => {
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const handleCopy = (value: string | null | undefined) => {
    if (!value) return;
    copy(value);
    setCopiedId(value);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const validIds = ids.filter((id) => id.value);

  return (
    <Popover>
      <SimpleTooltip label="Copy IDs">
        <PopoverTrigger asChild>
          <Button variant="outline">
            <Icon name="Copy" size="auto" />
          </Button>
        </PopoverTrigger>
      </SimpleTooltip>
      <PopoverContent className="w-80" align="start">
        <Stack gap={4}>
          <Text>Copy IDs</Text>
          {validIds.map((id) => (
            <Stack
              key={id.label}
              align="center"
              justify="between"
              className="rounded-md border p-2 pl-3"
              gap={2}
              direction="horizontal"
            >
              <div className="min-w-0 flex-1">
                <Text size="xs">{id.label}</Text>
                <Text className="truncate" color="tertiary" size="xs">
                  <span title={id.value ?? undefined}>{id.value}</span>
                </Text>
              </div>
              <Button
                variant="ghost"
                disabled={!id.value}
                onClick={() => handleCopy(id.value)}
              >
                <Icon
                  name={copiedId === id.value ? 'Check' : 'Copy'}
                  size="auto"
                />
              </Button>
            </Stack>
          ))}
        </Stack>
      </PopoverContent>
    </Popover>
  );
};
